import { render } from "./Home.vue?vue&type=template&id=e13de7fa&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=e13de7fa&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\99170\\Desktop\\whole-project\\iridea-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e13de7fa"]])

export default __exports__